import AxiosClient from "../../services/axios.services";

class LabsServices {
  getLabs = (params, type) =>
    AxiosClient.get(type === 1 ? `/api/app/Formal_Laboratorio/` : `/api/app/Funcional_Laboratorio/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveLabs = (data, type) =>
    AxiosClient.post(type === 1 ? `/api/app/Formal_Laboratorio/` : `/api/app/Funcional_Laboratorio/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  editLabs = (id, data, type) =>
    AxiosClient.put(type === 1 ? `/api/app/Formal_Laboratorio/${id}/` : `/api/app/Funcional_Laboratorio/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteLabs = (id, type) =>
    AxiosClient.delete(type === 1 ? `/api/app/Formal_Laboratorio/${id}/` : `/api/app/Funcional_Laboratorio/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new LabsServices();
